export default __webpack_public_path__ + "static/media/logo.9b6b8655.svg";